export type {
  TeachingPopoverCarouselPageCountProps,
  TeachingPopoverCarouselPageCountRenderFunction,
  TeachingPopoverCarouselPageCountSlots,
  TeachingPopoverCarouselPageCountState,
} from '@fluentui/react-teaching-popover';
